import styled from "styled-components";
import { FormPassengers as FormPassengersDefault } from "../../../../../forms/inputs/passengers/variants/simple/index.js";
import { Padding } from "../../../../../../styles/common/mixins/logical.styled.js";
export const FormPassengers = styled(FormPassengersDefault).withConfig({
    displayName: "styled__FormPassengers",
    componentId: "sc-476f9f77-0"
})`
	.input-without-label {
		${Padding({
    right: '22px',
    left: '16px'
})}
	}
`;

//# sourceMappingURL=styled.js.map